import { net } from '@/lib/net';

export interface RuleSet {
  id: string;
  label: string;
  url?: string;
  // a dropped file carries its text, a shipped one is fetched on first use
  xml?: string;
}

export const SHIPPED: RuleSet[] = [
  {
    id: 'walls-fire-rating',
    label: 'Walls carry a fire rating',
    url: '/ids/walls-fire-rating.ids',
  },
  {
    id: 'spaces-named-and-numbered',
    label: 'Spaces are named and numbered',
    url: '/ids/spaces-named-and-numbered.ids',
  },
  { id: 'raumbuch-din13080', label: 'Raumbuch DIN 13080', url: '/ids/raumbuch-din13080.ids' },
];

export async function readSet(set: RuleSet): Promise<string> {
  if (set.xml != null) return set.xml;
  if (!set.url) throw new Error(`rule set ${set.id} has no source`);
  const res = await net(set.url);
  if (!res.ok) throw new Error(`fetch ${set.url}: ${res.status}`);
  return res.text();
}
